import { ReactNode } from "react";
import { classNames } from "primereact/utils";
import { useDismissibleNote } from "./hooks/useDismissibleNote";
import styles from "./DismissibleNote.module.scss";

interface IDismissibleNoteProps {
  className?: string;
  /** Identifies the note in local storage - must stay stable across releases. */
  storageKey: string;
  title: string;
  text: ReactNode;
}

/**
 * A short explanatory note with a small "x" in the corner. Once closed it is
 * remembered per browser and never shown again, so onboarding copy does not keep
 * taking up space for returning users.
 */
export const DismissibleNote = ({
  className,
  storageKey,
  title,
  text,
}: IDismissibleNoteProps) => {
  const { isVisible, dismiss } = useDismissibleNote(storageKey);

  if (!isVisible) {
    return null;
  }

  return (
    <div className={classNames(styles.root, className)}>
      <div className={styles.root_header}>
        <h2 className={styles.root_header_title}>{title}</h2>

        <button
          type="button"
          className={styles.root_header_close}
          aria-label="Скрий обяснението"
          onClick={dismiss}
        >
          <i className="pi pi-times" />
        </button>
      </div>

      <p className={styles.root_text}>{text}</p>
    </div>
  );
};
